import * as React from 'react';
import { todayString } from 'src/utils/dates';
export default function TaskCardSubtitleV1(props) {
    var task = props.task;
    var externalCode = !task.externalCode
        ? null
        : React.createElement("div", null,
            React.createElement("small", null,
                "K\u00FCls\u0151 k\u00F3d (rajzsz\u00E1m): ",
                task.externalCode));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("small", null,
                "Hat\u00E1rid\u0151: ",
                todayString(new Date(task.deadline)))),
        React.createElement("div", null,
            React.createElement("small", null,
                "Partner: ",
                task.partnerName)),
        React.createElement("div", null,
            React.createElement("small", null,
                "Projekt: ",
                task.project)),
        React.createElement("div", null,
            React.createElement("small", null,
                "\u00DCtem: ",
                task.stepName)),
        React.createElement("div", null,
            React.createElement("small", null,
                "T\u00EDpus: ",
                task.taskType)),
        React.createElement("div", null,
            React.createElement("small", null,
                "Kompetencia: ",
                task.competency)),
        externalCode));
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskCardSubtitle.v1.tsx
// module id = 369
// module chunks = 0